import React from 'react'
import styled from 'styled-components'

import { BodyScrollLock } from 'components/styled'

export const HamburgerButton = styled.div`
  display: flex;
  align-items: center;
  text-decoration: none;
  outline: none;

  button {
    width: 20px;
    height: 2px;
    background-color: var(--gray-7);
    border: none;

    :after, :before {
      display: block;
      content: '';
      width: 20px;
      height: 2px;
      background-color: var(--gray-7);
      position: relative;
    }

    :after {
      top: -9px;
    }

    :before {
      bottom: -7px;
    }
  }

  &:after {
    display: ${props => props.active ? 'block' : 'none'};
    content: '';
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 400;
  }
`

export const MenuButton = ({ toggleMenu, active }) => (
  <HamburgerButton
    data-test='btn-hamburger-menu'
    onClick={toggleMenu}
    active={active}
  >
    <BodyScrollLock active={active} />
    <button data-test='btn-menu' />
  </HamburgerButton>
)

export default MenuButton
